import { render, staticRenderFns } from "./KongmingLanternSp.vue?vue&type=template&id=9dbbc150&scoped=true&"
import script from "./KongmingLanternSp.vue?vue&type=script&lang=js&"
export * from "./KongmingLanternSp.vue?vue&type=script&lang=js&"
import style0 from "./KongmingLanternSp.vue?vue&type=style&index=0&id=9dbbc150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbbc150",
  null
  
)

export default component.exports